import { render, staticRenderFns } from "./KomunitasKami.vue?vue&type=template&id=e838729a&scoped=true"
import script from "./KomunitasKami.vue?vue&type=script&lang=js"
export * from "./KomunitasKami.vue?vue&type=script&lang=js"
import style0 from "./KomunitasKami.vue?vue&type=style&index=0&id=e838729a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e838729a",
  null
  
)

export default component.exports